import { apiUrl } from '../apiBase';

const storageKey = (token) => `smartboard_teacher:${token}`;

export const readTeacherSession = (token) => {
  try { return window.sessionStorage.getItem(storageKey(token)); } catch (_) { return null; }
};
export const saveTeacherSession = (token, session) => window.sessionStorage.setItem(storageKey(token), session);
export const clearTeacherSession = (token) => {
  try { window.sessionStorage.removeItem(storageKey(token)); } catch (_) { /* Storage unavailable. */ }
};

export async function teacherRequest(token, path, session, options = {}) {
  const response = await fetch(apiUrl(`/mini-tasks/board/${encodeURIComponent(token)}/teacher/${path}`), {
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(session ? { 'X-Smartboard-Teacher-Session': session } : {}),
      ...options.headers,
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(typeof payload.detail === 'string' ? payload.detail : payload.detail?.message || 'İşlem tamamlanamadı.');
    error.status = response.status;
    error.code = payload.detail?.code;
    throw error;
  }
  return payload;
}
